import { HttpHeaders} from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { ErrorService } from '@app/core/error/error.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@app/core/auth/auth.service';
import { AbstractServiceWithoutToken } from './abstractServiceWithoutToken';

export abstract class AbstractService extends AbstractServiceWithoutToken {

  baseApiUrl = 'api';

  constructor(
    public environmentService: EnvironmentService,
    public router: Router,
    public errorService?: ErrorService,
    public activeModal?: NgbActiveModal
  ) {
    super(environmentService, router, errorService, activeModal);
  }

  getHeaders(contentType: string = 'application/json'): HttpHeaders {

    let header = new HttpHeaders();
    const token = AuthService.getToken();
    if (token) {
      header = header.append('Authorization', `Bearer ${token}`);
    }
    header = header.append('Content-Type', contentType);
    return header;
  }

}
